export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const COLORS = {
  black: "#212429",
  dark: "#2A2D32",
  primary: "var(--color-info-dark)",
  light: "rgba(256,256,256,0.498)",
  accent1: "var(--color-warning-dark)",
  accent2: "var(--color-danger)",
  muted: "rgba(255, 255, 255, 0.4)",
};

export const colorPalate = [
  "var(--color-danger)",
  "var(--color-warning-dark)",
  "var(--color-info-dark)",
];

export const priorityOptions = [
  {
    value: 0,
    label: " Lowest Priority",
    color: "blue",
  },
  {
    value: 1,
    label: "Medium Priority",
    color: "green",
  },
  {
    value: 2,
    label: "Needs Attention",
    color: "yellow",
  },
  {
    value: 3,
    label: "High Priority",
    color: "orange",
  },
  {
    value: 4,
    label: "Urgent",
    color: "red",
  },
];
export const productOptions = [
  {
    value: "patch",
    label: "patch",
  },
  {
    value: "beta",
    label: "beta",
  },
  {
    value: "group",
    label: "group",
  },
];
export const reasonOptions = [
  {
    value: 0,
    label: "Missed from count",
  },
  {
    value: 1,
    label: "Plotting Error",
  },
  {
    value: 2,
    label: "Plotting Error",
  },
  {
    value: 3,
    label: "Mis-Pressed",
  },
  {
    value: 4,
    label: "Sewing Error",
  },
  {
    value: 5,
    label: "Trimming Error",
  },
];

export const recutStatusOptions = [
  {
    value: 0,
    label: "Submitted - Waiting to be Plotted",
  },
  {
    value: 1,
    label: "Plotted - Waiting to be Pressed",
  },
  {
    value: 2,
    label: "Pressed - Waiting to be Sewn",
  },
  {
    value: 3,
    label: "Sewn - Waiting to be Trimmed",
  },
  {
    value: 4,
    label: "Trimmed - Waiting to be Shipped",
  },
  {
    value: 5,
    label: "Shipped",
  },
];

export const Days = [
  {
    value: "Monday",
    label: "Mon",
  },
  {
    value: "Tuesday",
    label: "Tue",
  },
  {
    value: "Wednesday",
    label: "Wed",
  },
  {
    value: "Thursday",
    label: "Thu",
  },
  {
    value: "Friday",
    label: "Fri",
  },
  {
    value: "Saturday",
    label: "Sat",
  },
  {
    value: "Sunday",
    label: "Sun",
  },
];

export const SM = "SM";
export const MD = "MD";
export const LG = "LG";
export const XL = "XL";

export const AUTH_TOKEN = "@autism-app:token";
export const USER_DATA = "@autism-app:userdata";
export const LOG_DATA = "@autism-app:logdata";
export const TASK_MODEL_VERSION = "@autism-app:taskModelVersion";
export const FIRST_TIME_AFTER_VERSION_UPDATE = "@autism-app:firstTimeAfterVersionUpdate";

export const LABELS = {
  expereince_type: "Experience Type",
  setting: "Setting",
  supervisor: "Supervisor",
  date_of_experience: "Date of Experience",
  // time_of_experience: "Time of Experience",
  time_of_expereince_start: "Time of Experience Start",
  time_of_expereince_end: "Time of Experience End",
  unrestricted_hours: "Unrestricted Hours",
  restricted_hours: "Restricted Hours",
  experience_hours: "Experience Hours",
  individual_or_group: "Individual or group supervision",
  method_of_supervision: "Method of Supervision",
  supervision_start_time: "Supervision Start Time",
  supervision_end_time: "Supervision End Time",
  supervised_hours: "Supervised Hours",
  independant_hours: "Independent Hours",
  client_observation: "Client Observation",
  supervision_contact: "Supervision contacts",
  task: "Task list items documented",
  experience_note: "Experience Notes",
};

export const TERMS = "Terms of Service";
export const PRIVACY = "Privacy Policy";

export const EXPERIENCE_TYPE_HELP = `Hey! What type of supervision are you getting?

Here’s a recap to help:

Supervised needs 2,000 hours babe.

Concentrated is hyperspeed with more contact. This version needs 1,500 hours and uses a 1.33 multiplier.

Still unsure? No sweat -ask your supervisor!
`;
export const SETTING_HELP =
  "Where are you recording hours? Are you in a clinic, home, school or community? #environment";
export const SUPERVISOR_HELP = "Who you asking to sign for these hours?";
export const DATE_OF_EXPERIENCE_HELP = "What day did you do this work?";
export const TIME_IN_HELP = "What time did this instance of experience start?";
export const TIME_OUT_HELP = "What time did this instance of experience end?";
export const UNRESTRICTED_HELP = `What is unrestricted? Pretty much any activity that is away from direct work with clients and is behavior analytic in nature. 

These things are 99% of what you will do in the future as a BCBA.

Examples: observation, training, data collection, conducting assessments, writing, graphing, research etc.

Non-examples: school stuff, administrative tasks, non-behavioral tasks, crisis management
`;
// export const RESTRICTED_HELP = `<p><strong>Restricted activities</strong> must be no more than <strong>40%</strong> of your total fieldwork hours. Don’t worry—you don’t have to meet this requirement <em>every</em> supervisory period, just in total.</p>

// <p><strong>Direct ABA services</strong> count as unrestricted hours—so more one-on-one, less admin!<br>
// #oneonone #directcare</p>
// `;
export const RESTRICTED_HELP = `Restricted activities must be no more than 40% of your total fieldwork hours.

Don’t worry—you don’t have to meet this requirement every supervisory period, just in total.

Direct ABA services count as unrestricted hours—so more one-on-one, less admin!
 #oneonone #directcare
`;
export const EXPERIENCE_HRS_HELP = `Number of total hours. These included both restricted and unrestricted hours
#exactCount
#PermanentProduct
`;
export const INDEPENDENT_HELP =
  "Who’s supervising you? \n\rIndividual: It’s just you and your single supervisor present";
export const GROUP_HELP =
  "Who’s supervising you? \n\rGroup: A supervisor is there, but there are other trainees present, but no more than 10.";
export const METHOD_OF_SUP_HELP =
  "Did you see your supervisor in person or on video? #IRL #Video \n\r\n\rBeware, phone calls don’t count in this category.";
export const SUP_START_HELP =
  "It’s specific to when the supervisor started. For instance if your experience starts at 9 AM and goes until 2 pm…. But you have supervision from 12 PM to 1 pm. This is where you’d log the time that was specific to just supervision";
export const SUP_END_HELP =
  "It’s specific to when the supervisor started. For instance if your experience starts at 9 AM and goes until 2 pm…. But you have supervision from 12 PM to 1 pm. This is where you’d log the time that was specific to just supervision";
export const SUPERVISED_HELP =
  "Hours accrued when a supervisor is present. These may include restricted or unrestricted activities observed by a supervisor or individual or group meetings with the supervisor.";
export const INDEPENDENT_HOURS_HELP =
  "How many hours did you spend #SOLO without your supervisor?";
export const OBSERVATION_HELP =
  "How many hours did your supervisor observe you with a client?";
export const SUPERVISION_CONTACT_HELP =
  "If your supervisor was present then this counts towards you supervision contact per supervisory period (4 contacts needed for supervised, 6 contacts needed concentrated). : A real-time interaction between the supervisor and trainee that takes place in an individual or group format.";
//export const RESTRICTED_HELP = ""
export const TASK_LIST_ITEM_HELP = `Record which topic (s) were covered in this experience hour(s). Tracking your experience will help you master the TCO
#negaitivereinforcemet 
`;
export const SUMMARY_HELP = `Prompts:
Tell me a bit about your session, who all was present? # environment

Tell me about your antecedents. What areas did you target to cover? What was the plan going into supervision?

Tell me about your behavior. What did you do EXACTLY be #technological

Tell me about your consequences and keep it behavioral. Did you meet any goals? Are there areas that still need to be addressed?
`;
export const SUMMARY_HELP_ARRAY = [
  "Tell me a bit about your session who all was present? # environment",
  "Tell me about your antecedents boo! What areas did you target to cover? What was the plan going into supervision?",
  "Tell me about your behavior. What did you do EXACTLY be #technological",
  "Tell me about your consequences and keep it behavioral babe! Did you meet any goals? Are there areas that still need to be addressed?",
];

export const TASK_LIST_GRID_LEGEND_HELP =
  "#fluency Did you know the more you practice each task list topic, utilizing behavior skills training, you’ll become competent. We think 10 opportunities within each topics the gold ticket. Work smarter not harder babe. And use our proprietary grid to watch your hard work unfold!";

export const HELPTEXT =
  "Duis elit, tempor in id. Massa quis id nec tincidunt consectetur eu ultricies cursus donec.";

export const TASKS_TABLE = [
  [
    {
      id: "A-1",
      description:
        "Identify the goals of behavior analysis as a science (i.e., description, prediction, control).",
    },
    {
      id: "B-1",
      description:
        "Define and provide examples of behavior, response, and response class.",
    },
    {
      id: "B-8",
      description:
        "Define and provide examples of unconditioned, conditioned, and generalized reinforcers and punishers.",
    },
    {
      id: "C-1",
      description: "Establish operational definitions of behavior.",
    },
    {
      id: "D-1",
      description: "Distinguish between dependent and independent variables.",
    },
    {
      id: "E-1",
      description: "Introduction",
    },
    {
      id: "F-1",
      description:
        "Review records and available data (e.g., educational, medical, historical) at the outset of the case.",
    },
    {
      id: "G-1",
      description:
        "Use positive and negative reinforcement procedures to strengthen behavior.",
    },
    {
      id: "G-12",
      description: "Use equivalence-based instruction.",
    },
    {
      id: "H-1",
      description:
        "State intervention goals in observable and measurable terms.",
    },
    {
      id: "I-1",
      description:
        "State the reasons for using behavior-analytic supervision and the potential risks of ineffective supervision (e.g., poor client outcomes, poor supervisee performance).",
    },
  ],
  [
    {
      id: "A-2",
      description:
        "Explain the philosophical assumptions underlying the science of behavior analysis (e.g., selectionism, determinism, empiricism, parsimony, pragmatism)",
    },
    {
      id: "B-2",
      description:
        "Define and provide examples of stimulus and stimulus class.",
    },
    {
      id: "B-9",
      description: "Define and provide examples of operant extinction.",
    },
    {
      id: "C-2",
      description:
        "Distinguish among direct, indirect, and product measures of behavior.",
    },
    {
      id: "D-2",
      description: "Distinguish between internal and external validity.",
    },
    {
      id: "E-2",
      description: "Responsibility as a Professional",
    },
    {
      id: "F-2",
      description: "Determine the need for behavior-analytic services.",
    },
    {
      id: "G-2",
      description:
        "Use interventions based on motivating operations and discriminative stimuli.",
    },
    {
      id: "G-13",
      description: "Use the high-probability instructional sequence.",
    },
    {
      id: "H-2",
      description:
        "Identify potential interventions based on assessment results and the best available scientific evidence.",
    },
    {
      id: "I-2",
      description:
        "Establish clear performance expectations for the supervisor and supervisee.",
    },
  ],
  [
    {
      id: "A-3",
      description:
        "Describe and explain behavior from the perspective of radical behaviorism.",
    },
    {
      id: "B-3",
      description:
        "Define and provide examples of respondent and operant conditioning.",
    },
    {
      id: "B-10",
      description: "Define and provide examples of stimulus control.",
    },
    {
      id: "C-3",
      description:
        "Measure occurrence (e.g., count, frequency, rate, percentage).",
    },
    {
      id: "D-3",
      description:
        "Identify the defining features of single-subject experimental designs (e.g., individuals serve as their own controls, repeated measures, prediction, verification, replication).",
    },
    {
      id: "E-3",
      description: "Responsibility in Practice",
    },
    {
      id: "F-3",
      description:
        "Identify and prioritize socially significant behavior-change goals.",
    },
    {
      id: "G-3",
      description: "Establish and use conditioned reinforcers.",
    },
    {
      id: "G-14",
      description:
        "Use reinforcement procedures to weaken behavior (e.g., DRA, FCT, DRO, DRL, NCR).",
    },
    {
      id: "H-3",
      description:
        "Recommend intervention goals and strategies based on such factors as client preferences, supporting environments, risks, constraints, and social validity.",
    },
    {
      id: "I-3",
      description:
        "Select supervision goals based on an assessment of the supervisee’s skills.",
    },
  ],
  [
    {
      id: "A-4",
      description:
        "Distinguish among behaviorism, the experimental analysis of behavior, applied behavior analysis, and professional practice guided by the science of behavior analysis.",
    },
    {
      id: "B-4",
      description:
        "Define and provide examples of positive and negative reinforcement contingencies.",
    },
    {
      id: "B-11",
      description:
        "Define and provide examples of discrimination, generalization, and maintenance.",
    },
    {
      id: "C-4",
      description:
        "Measure temporal dimensions of behavior (e.g., duration, latency, interresponse time).",
    },
    {
      id: "D-4",
      description:
        "Describe the advantages of single-subject experimental designs compared to group designs.",
    },
    {
      id: "E-4",
      description: "Responsibility to Clients and Stakeholders",
    },
    {
      id: "F-4",
      description:
        "Conduct assessments of relevant skill strengths and deficits.",
    },
    {
      id: "G-4",
      description:
        "Use stimulus and response prompts and fading (e.g., errorless, most-to-least, least-to-most, prompt delay, stimulus fading).",
    },
    {
      id: "G-15",
      description: "Use extinction.",
    },
    {
      id: "H-4",
      description:
        "When a target behavior is to be decreased, select an acceptable alternative behavior to be established or increased.",
    },
    {
      id: "I-4",
      description:
        "Train personnel to competently perform assessment and intervention procedures.",
    },
  ],
  [
    {
      id: "A-5",
      description:
        "Describe and define the dimensions of applied behavior analysis (Baer, Wolf, & Risley, 1968).",
    },
    {
      id: "B-5",
      description: "Define and provide examples of schedules of reinforcement.",
    },
    {
      id: "B-12",
      description: "Define and provide examples of motivating operations.",
    },
    {
      id: "C-5",
      description:
        "Measure form and strength of behavior (e.g., topography, magnitude).",
    },
    {
      id: "D-5",
      description:
        "Use single-subject experimental designs (e.g., reversal, multiple baseline, multielement, changing criterion).",
    },
    {
      id: "E-5",
      description: "Responsibility to Supervisees and Trainees",
    },
    {
      id: "F-5",
      description: "Conduct preference assessments.",
    },
    {
      id: "G-5",
      description: "Use modeling and imitation training.",
    },
    {
      id: "G-16",
      description:
        "Use positive and negative punishment (e.g., time-out, response cost, overcorrection).",
    },
    {
      id: "H-5",
      description:
        "Plan for possible unwanted effects when using reinforcement, extinction, and punishment procedures.",
    },
    {
      id: "I-5",
      description:
        "Use performance monitoring, feedback, and reinforcement systems.",
    },
  ],
  [
    null,
    {
      id: "B-6",
      description:
        "Define and provide examples of positive and negative punishment contingencies.",
    },
    {
      id: "B-13",
      description:
        "Define and provide examples of rule-governed and contingency-shaped behavior.",
    },
    {
      id: "C-6",
      description: "Measure trials to criterion.",
    },
    {
      id: "D-6",
      description:
        "Describe rationales for conducting comparative, component, and parametric analyses.",
    },
    {
      id: "E-6",
      description: "Responsibility in Public Statements",
    },
    {
      id: "F-6",
      description: "Describe the common functions of problem behavior.",
    },
    {
      id: "G-6",
      description: "Use instructions and rules.",
    },
    {
      id: "G-17",
      description: "Use token economies.",
    },
    {
      id: "H-6",
      description: "Monitor client progress and treatment integrity.",
    },
    {
      id: "I-6",
      description:
        "Use a functional assessment approach (e.g., performance diagnostics) to identify variables affecting personnel performance.",
    },
  ],
  [
    null,
    {
      id: "B-7",
      description:
        "Define and provide examples of automatic and socially mediated contingencies.",
    },
    {
      id: "B-14",
      description: "Define and provide examples of the verbal operants.",
    },
    {
      id: "C-7",
      description:
        "Design and implement sampling procedures (i.e., interval recording, time sampling).",
    },
    null,
    {
      id: "E-7",
      description: "Responsibility in Research",
    },
    {
      id: "F-7",
      description: "Conduct a descriptive assessment of problem behavior.",
    },
    {
      id: "G-7",
      description: "Use shaping.",
    },
    {
      id: "G-18",
      description: "Use group contingencies.",
    },
    {
      id: "H-7",
      description:
        "Make data-based decisions about the effectiveness of the intervention and the need for treatment revision.",
    },
    {
      id: "I-7",
      description:
        "Use function-based strategies to improve personnel performance.",
    },
  ],
  [
    null,
    null,
    {
      id: "B-15",
      description: "Define and provide examples of derived stimulus relations.",
    },
    {
      id: "C-8",
      description:
        "Evaluate the validity and reliability of measurement procedures.",
    },
    null,
    null,
    {
      id: "F-8",
      description: "Conduct a functional analysis of problem behavior.",
    },
    {
      id: "G-8",
      description: "Use chaining.",
    },
    {
      id: "G-19",
      description: "Use contingency contracting.",
    },
    {
      id: "H-8",
      description:
        "Make data-based decisions about the need for ongoing services.",
    },
    {
      id: "I-8",
      description:
        "Evaluate the effects of supervision (e.g., on client outcomes, on supervisee repertoires).",
    },
  ],
  [
    null,
    null,
    null,
    {
      id: "C-9",
      description:
        "Select a measurement system to obtain representative data given the dimensions of behavior and the logistics of observing and recording.",
    },
    null,
    null,
    {
      id: "F-9",
      description: "Interpret functional assessment data.",
    },
    {
      id: "G-9",
      description:
        "Use discrete-trial, free-operant, and naturalistic teaching arrangements.",
    },
    {
      id: "G-20",
      description: "Use self-management strategies.",
    },
    {
      id: "H-9",
      description:
        "Collaborate with others who support and/or provide services to clients.",
    },
    null,
  ],
  [
    null,
    null,
    null,
    {
      id: "C-10",
      description:
        "Graph data to communicate relevant quantitative relations (e.g., equal-interval graphs, bar graphs, cumulative records).",
    },
    null,
    null,
    null,
    {
      id: "G-10",
      description: "Teach simple and conditional discriminations.",
    },
    {
      id: "G-21",
      description:
        "Use procedures to promote stimulus and response generalization.",
    },
    null,
    null,
  ],
  [
    null,
    null,
    null,
    {
      id: "C-11",
      description: "Interpret graphed data.",
    },
    null,
    null,
    null,
    {
      id: "G-11",
      description: "Use Skinner’s analysis to teach verbal behavior.",
    },
    {
      id: "G-22",
      description: "Use procedures to promote maintenance.",
    },
    null,
    null,
  ],
];

export const TASKS_TABLE_SIXTH_EDITION = [
  // Row 1 (All .1 items)
  [
    {
      id: "A.1",
      description:
        "Identify the goals of behavior analysis as a science (i.e., description, prediction, control).",
    },
    {
      id: "B.1",
      description:
        "Identify and distinguish among behavior, response, and response class.",
    },
    {
      id: "B.13",
      description: "Identify examples of stimulus discrimination.",
    },
    { id: "C.1", description: "Create operational definitions of behavior." },
    {
      id: "D.1",
      description: "Distinguish between dependent and independent variables.",
    },
    {
      id: "E.1",
      description:
        "Identify and apply core principles underlying the ethics codes for BACB certificants (e.g., benefit others; treat others with compassion, dignity, and respect; behave with integrity).",
    },
    {
      id: "F.1",
      description:
        "Identify relevant sources of information in records (e.g., educational, medical, historical) at the outset of the case.",
    },
    {
      id: "G.1",
      description:
        "Design and evaluate positive and negative reinforcement procedures.",
    },
    {
      id: "G.13",
      description:
        "Design and evaluate trial-based and free-operant procedures.",
    },
    {
      id: "H.1",
      description:
        "Develop intervention goals in observable and measurable terms.",
    },
    {
      id: "I.1",
      description:
        "Identify the benefits of using behavior-analytic supervision (e.g., improved client outcomes, improved staff performance and retention).",
    },
  ],
  // Row 2 (All .2 items)
  [
    {
      id: "A.2",
      description:
        "Explain the philosophical assumptions underlying the science of behavior analysis (e.g., selectionism, determinism, empiricism, parsimony, pragmatism).",
    },
    {
      id: "B.2",
      description:
        "Identify and distinguish between stimulus and stimulus class.",
    },
    {
      id: "B.14",
      description:
        "Identify and distinguish between stimulus and response generalization.",
    },
    {
      id: "C.2",
      description:
        "Distinguish among direct, indirect, and product measures of behavior.",
    },
    {
      id: "D.2",
      description: "Distinguish between internal and external validity.",
    },
    {
      id: "E.2",
      description:
        "Identify the risks to oneself, others, and the profession as a result of engaging in unethical behavior.",
    },
    {
      id: "F.2",
      description:
        "Identify and integrate relevant cultural variables in the assessment process.",
    },
    {
      id: "G.2",
      description:
        "Design and evaluate differential reinforcement (e.g., DRA, DRO, DRL, DRH) procedures with and without extinction.",
    },
    { id: "G.14", description: "Design and evaluate group contingencies." },
    {
      id: "H.2",
      description:
        "Identify and recommend interventions based on assessment results, scientific evidence, client preferences, and contextual fit (e.g., expertise required for implementation, cultural variables, environmental resources).",
    },
    {
      id: "I.2",
      description:
        "Identify and apply strategies for establishing effective supervisory relationships (e.g., executing supervisor-supervisee contracts, establishing clear expectations, giving and accepting feedback).",
    },
  ],
  // Row 3 (All .3 items)
  [
    {
      id: "A.3",
      description:
        "Explain behavior from the perspective of radical behaviorism.",
    },
    {
      id: "B.3",
      description:
        "Identify and distinguish between respondent and operant conditioning.",
    },
    { id: "B.15", description: "Identify examples of response maintenance." },
    { id: "C.3", description: "Measure occurrence." },
    {
      id: "D.3",
      description:
        "Identify threats to internal validity (e.g., history, maturation).",
    },
    {
      id: "E.3",
      description:
        "Develop and maintain competence by engaging in professional development activities (e.g., read literature, seek consultation, establish mentors).",
    },
    {
      id: "F.3",
      description:
        "Design and evaluate assessments of relevant skill strengths and areas of need.",
    },
    {
      id: "G.3",
      description:
        "Design and evaluate time-based reinforcement (e.g., fixed-time) schedules.",
    },
    {
      id: "G.15",
      description:
        "Design and evaluate procedures to promote stimulus and response generalization.",
    },
    {
      id: "H.3",
      description:
        "Select socially valid alternative behavior to be established or increased when a target behavior is to be decreased.",
    },
    {
      id: "I.3",
      description:
        "Identify and implement methods that promote equity in supervision practices.",
    },
  ],
  // Row 4 (All .4 items)
  [
    {
      id: "A.4",
      description:
        "Distinguish among behaviorism, the experimental analysis of behavior, applied behavior analysis, and professional practice guided by the science of behavior analysis.",
    },
    {
      id: "B.4",
      description:
        "Identify and distinguish between positive and negative reinforcement contingencies.",
    },
    { id: "B.16", description: "Identify examples of motivating operations." },
    {
      id: "C.4",
      description:
        "Measure temporal dimensions of behavior (e.g., duration, latency, interresponse time).",
    },
    {
      id: "D.4",
      description:
        "Identify the defining features of single-case experimental designs (e.g., individuals serve as their own controls, repeated measures, prediction, verification, replication).",
    },
    {
      id: "E.4",
      description:
        "Identify and comply with requirements for collecting, using, protecting, and disclosing confidential information.",
    },
    { id: "F.4", description: "Design and evaluate preference assessments." },
    {
      id: "G.4",
      description:
        "Identify procedures to establish and use conditioned reinforcers (e.g., token economies).",
    },
    {
      id: "G.16",
      description:
        "Design and evaluate procedures to maintain desired behavior change following intervention (e.g., schedule thinning, transferring to naturally occurring reinforcers).",
    },
    {
      id: "H.4",
      description:
        "Plan for and attempt to mitigate possible unwanted effects when using reinforcement, extinction, and punishment procedures.",
    },
    {
      id: "I.4",
      description:
        "Select supervision goals based on an assessment of the supervisee's skills, cultural variables, and the environment.",
    },
  ],
  // Row 5 (All .5 items)
  [
    {
      id: "A.5",
      description:
        "Identify and describe dimensions of applied behavior analysis.",
    },
    {
      id: "B.5",
      description:
        "Identify and distinguish between positive and negative punishment contingencies.",
    },
    {
      id: "B.17",
      description:
        "Distinguish between motivating operations and stimulus control.",
    },
    {
      id: "C.5",
      description:
        "Distinguish between continuous and discontinuous measurement procedures.",
    },
    {
      id: "D.5",
      description:
        "Identify the relative strengths of single-case experimental designs and group designs.",
    },
    {
      id: "E.5",
      description:
        "Identify and comply with requirements for making public statements about professional activities (e.g., social media activity; misrepresentation of professional credentials, behavior analysis, and service outcomes).",
    },
    { id: "F.5", description: "Design and evaluate descriptive assessments." },
    {
      id: "G.5",
      description:
        "Incorporate motivating operations and discriminative stimuli into behavior-change procedures.",
    },
    {
      id: "G.17",
      description:
        "Design and evaluate positive and negative punishment (e.g., time-out, response cost, overcorrection).",
    },
    {
      id: "H.5",
      description:
        "Plan for and attempt to mitigate possible relapse of the target behavior.",
    },
    {
      id: "I.5",
      description:
        "Identify and apply empirically validated and culturally responsive performance management procedures (e.g., modeling, practice, feedback, reinforcement, task clarification, manipulation of response effort).",
    },
  ],
  // Row 6 (All .6 items)
  [
    null,
    {
      id: "B.6",
      description:
        "Identify and distinguish between automatic and socially mediated contingencies.",
    },
    {
      id: "B.18",
      description:
        "Identify and distinguish between rule-governed and contingency-shaped behavior.",
    },
    {
      id: "C.6",
      description:
        "Design and apply discontinuous measurement procedures (e.g., interval recording, time sampling).",
    },
    {
      id: "D.6",
      description:
        "Critique and interpret data from single-case experimental designs.",
    },
    {
      id: "E.6",
      description:
        "Identify the conditions under which services or supervision should be discontinued and apply steps that should be taken when transitioning clients and supervisees to another professional.",
    },
    { id: "F.6", description: "Design and evaluate functional analyses." },
    {
      id: "G.6",
      description:
        "Design and evaluate procedures to produce simple and conditional discriminations.",
    },
    {
      id: "G.18",
      description:
        "Evaluate emotional and elicited effects of behavior-change procedures.",
    },
    {
      id: "H.6",
      description: "Make data-based decisions about procedural integrity.",
    },
    {
      id: "I.6",
      description:
        "Apply a function-based approach (e.g., performance diagnostics) to assess and improve supervisee behavior.",
    },
  ],
  // Row 7 (All .7 items)
  [
    null,
    {
      id: "B.7",
      description:
        "Identify and distinguish among unconditioned, conditioned, and generalized reinforcers.",
    },
    {
      id: "B.19",
      description: "Identify and distinguish among verbal operants.",
    },
    {
      id: "C.7",
      description:
        "Measure efficiency (e.g., trials to criterion, cost-benefit analysis, training duration).",
    },
    {
      id: "D.7",
      description:
        "Distinguish among reversal, multiple-baseline, multielement, and changing-criterion designs.",
    },
    {
      id: "E.7",
      description:
        "Identify types of and risks associated with multiple relationships, and how to mitigate those risks when they are unavoidable.",
    },
    {
      id: "F.7",
      description:
        "Interpret assessment data to determine the need for behavior-analytic services and/or referral to others.",
    },
    {
      id: "G.7",
      description:
        "Select and evaluate stimulus and response prompting procedures (e.g., errorless, most-to-least, least-to-most).",
    },
    {
      id: "G.19",
      description:
        "Design and evaluate procedures to promote emergent relations and generative performance.",
    },
    {
      id: "H.7",
      description:
        "Make data-based decisions about the effectiveness of the intervention and the need for modification.",
    },
    {
      id: "I.7",
      description:
        "Make data-based decisions about the efficacy of supervisory practices.",
    },
  ],
  // Row 8 (All .8 items)
  [
    null,
    {
      id: "B.8",
      description:
        "Identify and distinguish among unconditioned, conditioned, and generalized punishers.",
    },
    {
      id: "B.20",
      description: "Identify the role of multiple control in verbal behavior.",
    },
    {
      id: "C.8",
      description:
        "Evaluate the validity and reliability of measurement procedures.",
    },
    {
      id: "D.8",
      description:
        "Identify rationales for conducting comparative, component, and parametric analyses.",
    },
    {
      id: "E.8",
      description:
        "Identify and apply interpersonal and other skills (e.g., accepting feedback, listening actively, seeking input, collaborating) to establish and maintain professional relationships.",
    },
    {
      id: "F.8",
      description:
        "Interpret assessment data to identify and prioritize socially significant, client-informed, and culturally responsive behavior-change procedures and goals.",
    },
    {
      id: "G.8",
      description:
        "Design and implement procedures to fade stimulus and response prompts (e.g., prompt delay, stimulus fading).",
    },
    null,
    {
      id: "H.8",
      description:
        "Collaborate with others to support and enhance client services.",
    },
    null,
  ],
  // Row 9 (All .9 items)
  [
    null,
    {
      id: "B.9",
      description:
        "Identify and distinguish among simple schedules of reinforcement.",
    },
    {
      id: "B.21",
      description:
        "Identify examples of processes that promote emergent relations and generative performance.",
    },
    {
      id: "C.9",
      description:
        "Select a measurement procedure to obtain representative data that accounts for the critical dimension of the behavior and environmental constraints.",
    },
    { id: "D.9", description: "Apply single-case experimental designs." },
    {
      id: "E.9",
      description:
        "Engage in cultural humility in service delivery and professional relationships.",
    },
    null,
    { id: "G.9", description: "Design and evaluate modeling procedures." },
    null,
    null,
    null,
  ],
  // Row 10 (All .10 items)
  [
    null,
    {
      id: "B.10",
      description:
        "Identify and distinguish among concurrent, multiple, mixed, and chained schedules of reinforcement.",
    },
    {
      id: "B.22",
      description:
        "Identify ways behavioral momentum can be used to understand response persistence.",
    },
    {
      id: "C.10",
      description:
        "Graph data to communicate relevant quantitative relations (e.g., equal-interval graphs, bar graphs, cumulative records).",
    },
    null,
    {
      id: "E.10",
      description:
        "Apply culturally responsive and inclusive service and supervision activities.",
    },
    null,
    { id: "G.10", description: "Design and evaluate instructions and rules." },
    null,
    null,
    null,
  ],
  // Row 11 (All .11 items)
  [
    null,
    {
      id: "B.11",
      description:
        "Identify and distinguish between operant and respondent extinction as operations and processes.",
    },
    {
      id: "B.23",
      description:
        "Identify ways the matching law can be used to interpret response allocation.",
    },
    { id: "C.11", description: "Interpret graphed data." },
    null,
    {
      id: "E.11",
      description:
        "Identify personal biases and how they might interfere with professional activity.",
    },
    null,
    { id: "G.11", description: "Shape dimensions of behavior." },
    null,
    null,
    null,
  ],
  // Row 12 (All .12 items)
  [
    null,
    { id: "B.12", description: "Identify examples of stimulus control." },
    {
      id: "B.24",
      description:
        "Identify and distinguish between imitation and observational learning.",
    },
    {
      id: "C.12",
      description:
        "Select a measurement procedure to obtain representative procedural integrity data that accounts for relevant dimensions (e.g., accuracy, dosage) and environmental constraints.",
    },
    null,
    {
      id: "E.12",
      description:
        "Identify and apply the legal, regulatory, and practice requirements (e.g., licensure, jurisprudence, funding, certification) relevant to the delivery of behavior-analytic services.",
    },
    null,
    { id: "G.12", description: "Select and implement chaining procedures." },
    null,
    null,
    null,
  ],
];

export const GRID_INFORMATION = [
  {
    topic: "Behaviorism and Philosophical Foundations",
    questionCount: 8,
    letter: "A",
  },
  {
    topic: "Concepts and Principles",
    questionCount: 24,
    letter: "B",
  },
  {
    topic: "Measurement, Data Display, and Interpretation",
    questionCount: 21,
    letter: "C",
  },
  {
    topic: "Experimental Design",
    questionCount: 13,
    letter: "D",
  },
  {
    topic: "Ethical and Professional Issues",
    questionCount: 22,
    letter: "E",
  },
  {
    topic: "Behavior Assessment",
    questionCount: 23,
    letter: "F",
  },
  {
    topic: "Behavior-Change Procedures",
    questionCount: 25,
    letter: "G",
  },
  {
    topic: "Selecting and Implementing Interventions",
    questionCount: 20,
    letter: "H",
  },
  {
    topic: "Personnel Supervision and Management",
    questionCount: 19,
    letter: "I",
  },
];

export const LOGIN_CONFIRMATION_MESSAGE = `<p>
  <strong>Hey there, look at you—being all responsible and logging your hours!</strong>
</p>

<p><br/>
  We know this part can feel overwhelming, but you're not in it alone. 
  We’re here to make the process easier and a lot less stressful.
</p>

<p>
  Need a little guidance? Just hover over the question marks for extra prompts and tips or head to our FAQs page. 
</p>
<p><em>We’re with you every step of the way.</em></p>
`;

export const V6_COMPULSORY_MESSAGE =
  "We're currently updating our platform to align with the BACB's 6th Edition Test Content Outline. The 5th Edition Task List is no longer supported for logging experience hours. Please add your entries using the 6th Edition Test Content Outline.";

export const TASK_VERSION_UPDATE_HELP =
  "This log contains tasks from the 5th Edition Task List. As of 2025, all tasks should follow the BACB's 6th Edition Test Content Outline. Please update your log to the current version or consult your supervisor regarding legacy data.";

export const FIRST_TIME_AFTER_VERSION_UPDATE_MESSAGE =
  `<div>
  <strong>Just a Heads-Up 👀</strong><br/><br/>
  <span>
    We're currently updating our platform to align with the BACB 6th Edition Test Content Outline (TCO). 
    The previous 5th Edition Task List is no longer supported for logging or tracking hours. 
    Please update your entries using the new 6th Edition TCO for accurate tracking.
  </span>
</div>
`